import { ApiResponse } from "./customerparts";

const API_URL = "https://api-agamhive.agamvanigam.com/gstslabs";
export const UNAUTHORIZED_EVENT = "unauthorized_access";
export interface GstSlab {
  _id?: string;
  gstType: string;
  gstName: string;
  gstPercentage: number;
  sgst: number | null;
  cgst: number | null;
  igst: number | null;
  status: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface GstSlabResponse {
  data: GstSlab[];
  total: number;
  page: number;
  limit: number;
  totalPages?: number;
}

interface FetchParams {
  page?: number;
  limit?: number;
  search?: string;
  filter?: Record<string, string | number | boolean>;
  sortBy?: string;
  sortOrder?: 'asc' | 'desc';
}

const handleUnauthorized = () => {
    console.error("Unauthorized access. Dispatching event for navigation...");
    localStorage.removeItem("authToken");
    
    const unauthorizedEvent = new CustomEvent(UNAUTHORIZED_EVENT);
    window.dispatchEvent(unauthorizedEvent);
    return { error: "Unauthorized. Please log in." };
};
const getAuthToken = () => localStorage.getItem("authToken") || "";
const getAuthHeaders = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const fetchGstSlabs = async (params: FetchParams = {}): Promise<ApiResponse<GstSlabResponse>> => {
  const token = getAuthToken();
  
  if (!token) return handleUnauthorized();
  
  try {
    const queryParams = new URLSearchParams({
      page: (params.page || 1).toString(),
      limit: (params.limit || 10).toString(),
      ...(params.search ? { search: params.search } : {}),
      ...(params.filter
        ? Object.fromEntries(Object.entries(params.filter).map(([key, value]) => [key, String(value)]))
        : {}),
      ...(params.sortBy ? { sortBy: params.sortBy } : {}),
      ...(params.sortOrder ? { sortOrder: params.sortOrder } : {})
    });
    
  
    
    const response = await fetch(`${API_URL}?${queryParams}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 401) {
      return handleUnauthorized();
  }

    
    const jsonResponse = await response.json();
    if (!response.ok) {
      return { error: jsonResponse.msg || "Failed to fetch GST slabs" };
    }
    
    return {
      data: {
        data: jsonResponse.data.data || [],
        total: jsonResponse.data.total || 0,
        page: jsonResponse.data.page || 1,
        limit: jsonResponse.data.limit || 10,
        totalPages: Math.ceil((jsonResponse.data.total || 0) / (jsonResponse.data.limit || 10))
      }
    };
  } catch (error) {
    return { error: "Network error. Please try again." };
  }
};

export const createGstSlab = async (slabData: GstSlab): Promise<any> => {
  const token = getAuthToken();
  
  if (!token) return handleUnauthorized();
  
  try {
    const response = await fetch(API_URL, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(slabData)
    });
    if (response.status === 401) {
      return handleUnauthorized();
  }

    
    const jsonResponse = await response.json();
    if (!response.ok) {
      return { error: jsonResponse.msg || "Failed to create GST slab" };
    }
    
    return response;
  } catch (error) {
    return { error: "Network error. Please try again." };
  }
};

export const updateGstSlab = async (slabId: string, slabData: GstSlab): Promise<ApiResponse<GstSlab>> => {
  const token = getAuthToken();
  
  if (!token) return handleUnauthorized();
  
  try {
    const response = await fetch(`${API_URL}/${slabId}`, {
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(slabData)
    });
    if (response.status === 401) {
      return handleUnauthorized();
  }

    const jsonResponse = await response.json();
    if (!response.ok) {
      return { error: jsonResponse.msg || "Failed to update GST slab" };
    }
    
    return { data: jsonResponse.data };
  } catch (error) {
    return { error: "Network error. Please try again." };
  }
};

export const deleteGstSlab = async (slabId: string): Promise<ApiResponse<any>> => {
  const token = getAuthToken();
  
  if (!token) return handleUnauthorized();
  
  try {
    const response = await fetch(`${API_URL}/${slabId}`, {
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    if (response.status === 401) {
      return handleUnauthorized();
  }

    const jsonResponse = await response.json();
    if (!response.ok) {
      return { error: jsonResponse.msg || "Failed to delete GST slab" };
    }
    
    return { data: jsonResponse.data };
  } catch (error) {
    return { error: "Network error. Please try again." };
  }
};